<template>
  <div class="content">
    <div class="water-temperature-live">
      <div class="publish-time" v-if="liveMap.ddatetime">
        <!--        <i class="el-icon-time"></i>-->
        <!--        数据时间：{{ $moment(slideLiveResult.time[slideLiveResult.time.length - 1]).format('YYYY-MM-DD HH:mm') }}-->
        <div>{{ $moment(liveMap.ddatetime * 1000).format('YYYY-MM-DD HH:mm')  }}更新</div>
      </div>
      <div class="water-temperature-live-wrap" v-show="liveMap.ddatetime">
        <div class="more"><div class="more_btn" @click="handleOpenMore()"><div>更多&nbsp;</div><div class="dy">&gt;</div></div></div>
        <div class="water-temperature-live-list" ref="hourForecastList">
          <div class="temperature-item" v-for="i in 4" :key="i">
            <div class="temperature-title">{{tempMList[i - 1]}}m温度</div>
            <div class="temperature-val-warp">
              <div class="val">{{liveMap['t' + (i-1)]}}</div>
              <div class="unit">℃</div>
            </div>
            <div class="temperature-line"></div>
            <div class="temperature-24">24h变温</div>
            <div class="temperature-bw-val">{{liveMap['t' + (i-1) + 'b']}}℃</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import echarts from '@/config/echarts/index.js'
import { mapMutations, mapState } from 'vuex'
import { getLiveOption } from '@/config/echarts/option/water-temperature-live'
export default {
  props: ['params', 'forecastType', 'cardEchart'],
  data () {
    return {
      liveMap: {},
      tempMList: [1, 2, 2.5, 3.2]
    }
  },
  watch: {
    activeCountyId: {
      handler () {
        setTimeout(() => {
          this.$nextTick(() => {
            this.getLiveData()
          })
        }, 100)
      },
      immediate: true
    },
    forecastType () {
      this.resetEchart()
    },
    shuiWenStationSlideResult: {
      handler () {
        this.$nextTick(() => {
          this.getLiveData()
        })
      },
      deep: true
    }
  },
  computed: {
    ...mapState('home', ['objsList', 'activeCountyId', 'shuiWenStationSlideResult'])
  },
  methods: {
    async getLiveData () {
      const shuiWenStationSlideResult = this.shuiWenStationSlideResult
      if (!shuiWenStationSlideResult.liveMap) {
        return
      }
      this.liveMap = shuiWenStationSlideResult.liveMap
    },
    handleOpenMore () {
      this.$bus.$emit('showWaterTempChart')
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 2.6vw 1.04vw 0.56vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  border-radius: 0.63vw;
  overflow: hidden;
  .water-temperature-live {
    .water-temperature-live-wrap {
      .more {
        position: relative;
        font-size: 12px;
        color: #FFFFFF;
        margin: 0.3vh 0;
        cursor: default;
        opacity: 0.41; /* 设定背景图片的透明度 */
        .more_btn {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .dy {
            position: relative;
            top: -1.5px;
          }
        }
      }
      .water-temperature-live-list {
        display: flex;
        height: 100%;
        justify-content: space-between;
        .temperature-item {
          flex: 1;
          height: 12.8vh;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-right: 0.5vw;
          padding: 0.5vh 0.5vw;
          opacity: 0.8;
          border: 2px solid;
          position: relative;
          border-image: linear-gradient(135deg, rgba(112, 176, 247, 1), rgba(78, 133, 211, 0), rgba(112, 178, 250, 1)) 2 2;
          &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            border-radius: inherit; /* 继承父元素的圆角 */
            border-image: linear-gradient(135deg, rgba(112, 176, 247, 1), rgba(78, 133, 211, 0), rgba(112, 178, 250, 1)) 2 2;
            background: linear-gradient( 135deg, rgba(106,152,199,0.47) 0%, rgba(87,86,141,0.48) 51%, rgba(60,108,112,0.5) 100%);
            opacity: 0.41; /* 设定背景图片的透明度 */
            z-index: -1; /* 确保伪元素位于元素内容之下 */
          }
          &:last-child {
            margin-right: 0;
          }
          .temperature-title {
            color: #FFFFFF;
            font-size: 1.60vh;
            white-space: nowrap;
            margin-bottom: 1px;
            opacity: 0.8;
          }
          .temperature-line {
            border: none;
            border-bottom: 2px dashed #FFFFFF;
            height: 1px;
            width: 100%;
            opacity: 0.17;
            margin: 0.2vh 0 0.5vh 0;
          }
          .temperature-val-warp {
            display: flex;
            position: relative;
            color: #fff;
            margin: 0.25vh 0;
            .val {
              font-weight: 500;
              font-size: 2.7vh;
            }
            .unit {
              font-size: 1.7vh;
            }
          }
          .temperature-24 {
            color: #85D2FF;
            font-size: 1.65vh;
            margin-bottom: 0.6vh;
          }
          .temperature-bw-val {
            font-size: 1.65vh;
            color: #fff;
          }
        }
      }
    }
  }

  // pointer-events: none;
  .publish-time {
    display: flex;
    align-items: center;
    position: absolute;
    right: 2.08vw;
    top: .8vw;
    color: #FFF;
    font-size: 0.63vw;

    .el-icon-time {
      margin-right: 0.26vw;
    }
  }
}
</style>
